/* OVD editorial video autopilot v4.
   No IntersectionObserver (it is unreliable/neutered in some environments and
   silently never fires). Plain rAF-throttled scroll checks: force play() when
   an editorial video is on screen, pause it when it leaves. Covers full loads,
   SPA swaps, below-fold starts, iOS Low Power. */
(function () {
  if (window.__ovdVideoKick4) return;
  window.__ovdVideoKick4 = true;

  /* Load gate: no video bytes before the window load event — the poster paints
     first and the video starts a beat later. Design-identical, metric-clean. */
  var loadGateOpen = document.readyState === 'complete';
  if (!loadGateOpen) addEventListener('load', function () {
    setTimeout(function () { loadGateOpen = true; }, 150);
  });
  var SEL = '.pstory-media video, .lb-media video, .dropcd-bg video, video[data-ovd-lazyvideo]';

  /* Videos marked data-ovd-lazyvideo start with preload="none" and no autoplay.
     Off screen we do not just pause them — we strip the <source> src values and
     call load(), which tears the decoder down and hands the memory back. Pausing
     alone leaves the decoded frame buffers resident, which is what was costing
     ~65MB on the home page. */
  function isLazy(v) { return v.hasAttribute('data-ovd-lazyvideo'); }

  function release(v) {
    if (!isLazy(v) || v.dataset.ovdOn === '0') return;
    try { v.pause(); } catch (e) {}
    var srcs = v.querySelectorAll('source');
    for (var i = 0; i < srcs.length; i++) {
      if (srcs[i].src) { srcs[i].dataset.ovdSrc = srcs[i].src; srcs[i].removeAttribute('src'); }
    }
    try { v.load(); } catch (e) {}   // back to the poster
    v.dataset.ovdOn = '0';
  }

  function engage(v) {
    if (!isLazy(v)) return;
    if (v.dataset.ovdOn === '1') return;
    var srcs = v.querySelectorAll('source'), restored = false;
    for (var i = 0; i < srcs.length; i++) {
      if (!srcs[i].src && srcs[i].dataset.ovdSrc) { srcs[i].src = srcs[i].dataset.ovdSrc; restored = true; }
    }
    if (restored || v.readyState === 0) { try { v.load(); } catch (e) {} }
    v.dataset.ovdOn = '1';
  }

  function onScreen(v) {
    var r = v.getBoundingClientRect();
    if (!r.height) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > vh * 0.05 && r.top < vh * 0.95;
  }
  function tryPlay(v) {
    if (!loadGateOpen) return; /* the sweep retries; it will start right after load */
    engage(v);
    if (!v.paused) return;
    v.muted = true;
    v.setAttribute('playsinline', '');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function sweep() {
    var vids = document.querySelectorAll(SEL);
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (onScreen(v)) tryPlay(v);
      else if (isLazy(v)) release(v);
      else if (!v.paused) { try { v.pause(); } catch (e) {} }
    }
  }

  var ticking = false;
  function queueSweep() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { sweep(); ticking = false; });
  }

  window.addEventListener('scroll', queueSweep, { passive: true });
  window.addEventListener('resize', queueSweep, { passive: true });
  document.addEventListener('ovd:rescan', function () { setTimeout(sweep, 150); });
  ['barba:after', 'barba:enter'].forEach(function (ev) {
    window.addEventListener(ev, function () { setTimeout(sweep, 250); });
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      /* backgrounded tab: hand every lazy video's memory back */
      var vids = document.querySelectorAll(SEL);
      for (var i = 0; i < vids.length; i++) release(vids[i]);
    } else sweep();
  });
  ['touchstart', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function () { queueSweep(); }, { capture: true, passive: true });
  });
  // Steady heartbeat catches everything else (video injected mid-page, slow
  // buffering finishing, autoplay rejections resolving after first gesture).
  setInterval(sweep, 1200);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
})();
